import { createContext, useContext } from 'react';
import type { Workspace } from './workspaces-api';

export const CurrentWorkspaceContext = createContext<Workspace | null>(null);

/** Открытое пространство (`/w/:workspaceId/…`) с моими правами. */
export function useCurrentWorkspace(): Workspace {
  const workspace = useContext(CurrentWorkspaceContext);
  if (workspace === null) throw new Error('useCurrentWorkspace outside a workspace route');
  return workspace;
}
